import { v4 as uuid } from 'uuid';

export const MSG_USER_ROLE = { EMPLOYER: 'employer', CANDIDATE: 'candidate' };
export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed'
};

export const USER_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline'
};

export const trimEmptyParagraphs = (html) => {
  if (!html) return html;
  // Match <p> with any attributes, containing only whitespace/&nbsp;/<br> with any attributes
  const emptyP = /^\s*<p[^>]*>(\s|&nbsp;|<br[^>]*\/?>)*<\/p>\s*/i;
  const emptyPEnd = /\s*<p[^>]*>(\s|&nbsp;|<br[^>]*\/?>)*<\/p>\s*$/i;
  let out = html;
  let prev;
  // 1. Strip fully-empty leading paragraphs
  do {
    prev = out;
    out = out.replace(emptyP, '');
  } while (out !== prev);
  // 2. Strip fully-empty trailing paragraphs
  do {
    prev = out;
    out = out.replace(emptyPEnd, '');
  } while (out !== prev);
  // 3. Strip leading <br>/&nbsp;/whitespace INSIDE the first paragraph
  //    (Tiptap emits blank lines from Shift+Enter as <br> before the text: <p><br><br>text</p>)
  out = out.replace(/^(\s*<p[^>]*>)((\s|&nbsp;|<br[^>]*\/?>)+)/i, '$1');
  // 4. Strip trailing <br>/&nbsp;/whitespace INSIDE the last paragraph
  out = out.replace(/((\s|&nbsp;|<br[^>]*\/?>)+)(<\/p>\s*)$/i, '$3');
  return out.trim();
};

export const serializeMessageHtml = (html) => {
  const trimmed = trimEmptyParagraphs(html);
  return trimmed?.replace(/<p><\/p>/g, '<p>&nbsp;</p>');
};

export const createMessageData = (activeChatId, newMessage, activeChatInfo) => ({
  id: uuid(),
  recipientId: activeChatId,
  content: newMessage,
  recipientType: MSG_USER_ROLE.CANDIDATE,
  email: activeChatInfo.email,
  name: activeChatInfo.first_name,
  status: MESSAGE_STATUS.SENDING,
  messageType: 'text'
});

export const handleSocketResponse = (response) => {
  if (!response) {
    throw new Error('No response from server');
  }

  if (response.success) {
    return response.data;
  }

  const errorMessages = {
    AUTH_FAILED: 'You are not authorized. Please log in again.',
    VALIDATION_FAILED: 'Message format is invalid.',
    RATE_LIMITED: 'You are sending messages too quickly. Try again later.',
    INTERNAL_ERROR: 'Something went wrong. Please try again.',
    default: 'Something went wrong. Please try again.'
  };

  const message = response.message || errorMessages[response?.errorCode] || errorMessages.default;

  if (response.data) return response?.data;
  else return message;
};
